import CallNotConnected from "@assets/svg/MyTasks/CallNotConnected";
import DeliveryConfirm from "@assets/svg/MyTasks/DeliveryConfirm";
import RescheduleToday from "@assets/svg/MyTasks/RescheduleToday";

export interface Action {
  key: string;
  value: string;
  value2: string;
  subvalue: string;
  hint: string;
  color: string;
  icon: any;
  action: string;
  disable_on_d_minus_2: boolean;
}

export const getActionIcon = (icon: string) => {
  switch (icon) {
    case "CallNotConnected":
      return CallNotConnected;
    case "DeliveryConfirm":
      return DeliveryConfirm;
    default:
      return null;
  }
};

export const getActions = (type: string, actions: Action[]): Action[] => {
  const actionsCopy = [...actions];
  if (type === "EDIT") {
    return actionsCopy;
  }
  if (type === "RESCHEDULE") {
    return actionsCopy.filter((item) =>
      ["RESCHEDULED_FOR_TOMORROW"].includes(item.action),
    );
  }
  return actionsCopy.filter((item) => !["CLEAR_STATUS"].includes(item.action));
};
